import React from "react";
import PinInput from "react-pin-input";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";

import api from "~/services/api";
import { setToken } from "~/services/token";
import { getCurrentDomain } from "~/utils";
import config from "~/config";

import "./Email.scss";
import ButtonSecondary from "../Button/ButtonSecondary";
import ButtonPrimary from "../Button/ButtonPrimary";

export default function Code({ email, fetchMe, onHide }) {
  const captchaEnable = useSelector((store) => store.configs.captcha_enable);
  const captchaRef = React.useRef(null);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const [code, setCode] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);

  function handleCodeChange(value) {
    setCode(value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);

    const domain = getCurrentDomain();

    let body = {
      method: "email_code",
      username: email,
      password: code,
      appcode: config.appcode,
      domain
    }

    if (captchaEnable && !captchaToken) {
      setError("Selecione o reCAPTCHA.");
      return;
    }

    if (captchaEnable) {
      body.captcha_token = captchaToken
    }

    api
      .post(`/v1/login`, body)
      .then(({ data }) => {
        const { token } = data;

        setToken(token);
        fetchMe();
      })
      .catch((err) => {
        if (captchaEnable) {
          captchaRef.current.reset();
          setCaptchaToken(null);
        }
        setError(err?.response?.data?.message || "Ocorreu um error ao tentar acessar com o código de verificação!");
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  const disabled = code.length !== 4 || submitting || (captchaEnable && !captchaToken);

  return (
    <div className="login-email">
      <div className="text">
        <h1>Autenticação</h1>
        <p>
          Seu código de acesso foi enviado para o e-mail
          <br />
          <strong className="email">{email}</strong>
        </p>
        <span>* Verifique também a caixa de spam</span>
        {error && <span>{error}</span>}
      </div>

      <form onSubmit={handleSubmit}>
        <div className="code">
          <PinInput
            length={4}
            focus
            type="numeric"
            onChange={handleCodeChange}
            onComplete={handleCodeChange}
          />
        </div>

        {captchaEnable && (
          <div className="login-recaptcha">
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={config.captchaSiteKey}
              onChange={(token) => {
                if (token) setCaptchaToken(token);
              }}
              onExpired={() => {
                setCaptchaToken(null);
              }}
              onErrored={() => {
                setCaptchaToken(null);
                captchaRef.current.reset();
              }}
            />
          </div>
        )}

        <div className="actions">
          <ButtonSecondary type="button" onClick={onHide}>
            Voltar
          </ButtonSecondary>
          <ButtonPrimary disabled={disabled}>
            {submitting ? "Aguarde..." : "OK"}
          </ButtonPrimary>
        </div>
      </form>
    </div>
  );
}
